import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KpiResultPeriod } from '@masar/common/models';
import { KpiMeasurementCycleType } from '@masar/common/types';

@Component({
    selector: 'app-kpi-result-periods-breakdown-dialog',
    templateUrl: './kpi-result-periods-breakdown-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class KpiResultPeriodsBreakdownDialogComponent {
    @Input() public periods: KpiResultPeriod[];
    @Input() public measurementCycle: KpiMeasurementCycleType;
}
